import React from 'react'
import './stylesheet/heading.css'

export const Heading = ({heading}) => {
    return (
        <>
            <p className="login_heading">{heading}</p>
        </>
    )
}
